import React from 'react';
import '../template-file-css/document-file-template.css';


export const JHC_AdolescentIntakePacket = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='JHC_AdolescentIntakePacket' className='file-pdf-document'>

            <div className='file-template'>

                <table>
                    <tr>
                        <td className='w-250'> <span className='eleHeader'>Child's Name:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Age:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Birthdate:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'>  <input id='txtChildName' name='txtChildName' type='text' className='add-only' /> </td>
                        <td className='w-250'>  <input id='txtChildAge' name='txtChildAge' type='text' className='add-only' /> </td>
                        <td className='w-250'>  <input id='txtChildBirthdate' name='txtChildBirthdate' type='date' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <span className='eleHeader'>Street Address:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>City/State/Zip:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Phone:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'>  <input id='txtStreetAddress' name='txtStreetAddress' type='text' className='add-only' /> </td>
                        <td className='w-250'>  <input id='txtCityStateZip' name='txtCityStateZip' type='text' className='add-only' /> </td>
                        <td className='w-250'>  <input id='txtPhone' name='txtPhone' type='text' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-300'> <span className='eleHeader'>Ethnicity:</span> </td>
                        <td className='w-450'> <span className='eleHeader'>Gender:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-300'>  <input id='txtEthnicity' name='txtEthnicity' type='text' className='add-only' /> </td>
                        <td className='w-450'>
                            <input type='radio' id='rbGender_Male' name='rbGender' className='add-only' value='Male' /> Male &nbsp;
                            <input type='radio' id='rbGender_Female' name='rbGender' className='add-only' value='Female' /> Female &nbsp;
                            <input type='radio' id='rbGender_LGBTQ' name='rbGender' className='add-only' value='LGBTQ' /> LGBTQ  &nbsp;
                            <input type='radio' id='rbGender_Other' name='rbGender' className='add-only' value='Other' />  Other
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>What is your primary Language?</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Name of person accompanying client today:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>  <input id='txtPrimaryLanguage' name='txtPrimaryLanguage' type='text' className='add-only' /> </td>
                        <td className='w-375'>  <input id='txtPersonAccompanyingClient' name='txtPersonAccompanyingClient' type='text' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Relationship to client:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>  <input id='txtRelationshipClient' name='txtRelationshipClient' type='text' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-250'> <span className='eleHeader'>Mother's Name:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Age:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Birthdate:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'>  <input id='txtMotherName' name='txtMotherName' type='text' className='add-only' /> </td>
                        <td className='w-250'>  <input id='txtMotherAge' name='txtMotherAge' type='text' className='add-only' /> </td>
                        <td className='w-250'>  <input id='txtMotherBirthdate' name='txtMotherBirthdate' type='date' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <span className='eleHeader'>Street Address:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>City/State/Zip:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Phone:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'>  <input id='txtMotherStreetAddress' name='txtMotherStreetAddress' type='text' className='add-only' /> </td>
                        <td className='w-250'>  <input id='txtMotherCityStateZip' name='txtMotherCityStateZip' type='text' className='add-only' /> </td>
                        <td className='w-250'>  <input id='txtMotherPhone' name='txtMotherPhone' type='text' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Marital Status:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbMaritalStatus_Single' name='rbMaritalStatus' className='add-only' value='Single' /> Single &nbsp;
                            <input type='radio' id='rbMaritalStatus_Married' name='rbMaritalStatus' className='add-only' value='Married' /> Married &nbsp;
                            <input type='radio' id='rbMaritalStatus_Separated' name='rbMaritalStatus' className='add-only' value='Separated' /> Separated &nbsp;
                            <input type='radio' id='rbMaritalStatus_Divorced' name='rbMaritalStatus' className='add-only' value='Divorced' /> Divorced &nbsp;
                            <input type='radio' id='rbMaritalStatus_Remarried' name='rbMaritalStatus' className='add-only' value='Remarried' /> Remarried &nbsp;
                            <input type='radio' id='rbMaritalStatus_Widowed' name='rbMaritalStatus' className='add-only' value='Widowed' /> Widowed
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Name of Mother's Spouse or Partner (if applicable):</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>  <input id='txtMotherSpousePartner' name='txtMotherSpousePartner' type='text' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-250'> <span className='eleHeader'>Father's Name:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Age:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Birthdate:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'>  <input id='txtFatherName' name='txtFatherName' type='text' className='add-only' /> </td>
                        <td className='w-250'>  <input id='txtFatherAge' name='txtFatherAge' type='text' className='add-only' /> </td>
                        <td className='w-250'>  <input id='txtFatherBirthdate' name='txtFatherBirthdate' type='date' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <span className='eleHeader'>Street Address:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>City/State/Zip:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Phone:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'>  <input id='txtFatherStreetAddress' name='txtFatherStreetAddress' type='text' className='add-only' /> </td>
                        <td className='w-250'>  <input id='txtFatherCityStateZip' name='txtFatherCityStateZip' type='text' className='add-only' /> </td>
                        <td className='w-250'>  <input id='txtFatherPhone' name='txtFatherPhone' type='text' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Marital Status:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbMaritalStatus_Single' name='rbMaritalStatus' className='add-only' value='Single' /> Single &nbsp;
                            <input type='radio' id='rbMaritalStatus_Married' name='rbMaritalStatus' className='add-only' value='Married' /> Married &nbsp;
                            <input type='radio' id='rbMaritalStatus_Separated' name='rbMaritalStatus' className='add-only' value='Separated' /> Separated &nbsp;
                            <input type='radio' id='rbMaritalStatus_Divorced' name='rbMaritalStatus' className='add-only' value='Divorced' /> Divorced &nbsp;
                            <input type='radio' id='rbMaritalStatus_Remarried' name='rbMaritalStatus' className='add-only' value='Remarried' /> Remarried &nbsp;
                            <input type='radio' id='rbMaritalStatus_Widowed' name='rbMaritalStatus' className='add-only' value='Widowed' /> Widowed
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Name of Father's Spouse or Partner (if applicable):</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>  <input id='txtFatherSpousePartner' name='txtFatherSpousePartner' type='text' className='add-only' /> </td>
                    </tr>


                    <tr>
                        <td className='w-750'> <span className='eleHeader'>If parents are divorced/separated, who has legal custody of child?  </span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbLegalCustody_Mother' name='rbLegalCustody' className='add-only' value='Mother' /> Mother &nbsp;
                            <input type='radio' id='rbLegalCustody_Father' name='rbLegalCustody' className='add-only' value='Father' /> Father &nbsp;
                            <input type='radio' id='rbLegalCustody_Joint' name='rbLegalCustody' className='add-only' value='Joint' /> Joint &nbsp;
                            <input type='radio' id='rbLegalCustody_Other' name='rbLegalCustody' className='add-only' value='Other' /> Other:

                            <input id='txtLegalCustody_Other' name='txtLegalCustody_Other' type='text' className='add-only w-200 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'> Please list siblings, parents, stepparents, etc. </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <span className='eleHeader'>Name:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Relationship:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Age:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'>  <input id='txtListName' name='txtListName' type='text' className='add-only' /> </td>
                        <td className='w-250'>  <input id='txtListRelationship' name='txtListRelationship' type='text' className='add-only' /> </td>
                        <td className='w-250'>  <input id='txtListAge' name='txtListAge' type='text' className='add-only' /> </td>
                    </tr>
                </table>

                <table>

                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Name of School child is currently attending:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Grade:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>  <input id='txtSchoolName' name='txtSchoolName' type='text' className='add-only' /> </td>
                        <td className='w-375'>  <input id='txtGrade' name='txtGrade' type='text' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>School Address:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Teacher' Name:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>  <input id='txtSchoolAddress' name='txtSchoolAddress' type='text' className='add-only' /> </td>
                        <td className='w-375'>  <input id='txtTeacherName' name='txtTeacherName' type='text' className='add-only' /> </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Referred by:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbReferredBy_1' name='cbReferredBy_1' className='add-only' value='Self' /> Self</td>
                        <td className='w-250'><input type='checkbox' id='cbReferredBy_2' name='cbReferredBy_2' className='add-only' value='Hospital' /> Hospital</td>
                        <td className='w-250'><input type='checkbox' id='cbReferredBy_3' name='cbReferredBy_3' className='add-only' value='Family/Friend' /> Family/Friend</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbReferredBy_4' name='cbReferredBy_4' className='add-only' value='School' /> School</td>
                        <td className='w-250'><input type='checkbox' id='cbReferredBy_5' name='cbReferredBy_5' className='add-only' value='Court' /> Court</td>
                        <td className='w-250'><input type='checkbox' id='cbReferredBy_6' name='cbReferredBy_6' className='add-only' value='Physician' /> Physician</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbReferredBy_7' name='cbReferredBy_7' className='add-only' value='MHSD' /> MHSD</td>
                        <td className='w-250'><input type='checkbox' id='cbReferredBy_8' name='cbReferredBy_8' className='add-only' value='Probation Officer' /> Probation Officer</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbReferredBy_9' name='cbReferredBy_9' className='add-only' value='Other ' /> Other:
                            <input type='text' id='txtReferredBy_9Other' name='txtReferredBy_9Other' className='add-only w-200 custom-add-only' />

                        </td>
                    </tr>


                </table>


                <table>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Name:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Relationship:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>  <input id='txtEmergencyName' name='txtEmergencyName' type='text' className='add-only' /> </td>
                        <td className='w-375'>  <input id='txtEmergencyRelationship' name='txtEmergencyRelationship' type='text' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <span className='eleHeader'>Street Address:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>City/State/Zip:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Phone:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'>  <input id='txtEmergencyStreetAddress' name='txtEmergencyStreetAddress' type='text' className='add-only' /> </td>
                        <td className='w-250'>  <input id='txtEmergencyCityStateZip' name='txtEmergencyCityStateZip' type='text' className='add-only' /> </td>
                        <td className='w-250'>  <input id='txtEmergencyPhone' name='txtEmergencyPhone' type='text' className='add-only' /> </td>
                    </tr>


                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Reason for Referral:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Other:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>  <input id='txtReasonReferral' name='txtReasonReferral' type='text' className='add-only' /> </td>
                        <td className='w-375'>  <input id='txtReasonReferralOther' name='txtReasonReferralOther' type='text' className='add-only' /> </td>
                    </tr>

                </table>
                <p className='w-750' >
                    <span className='eleHeader'>Do you have any urgent needs?</span>
                    <textarea id='txtUrgentNeeds' name='txtUrgentNeeds' className='add-only'></textarea>
                </p>
                <p className='w-750' >
                    <span className='eleHeader'>Do you have any critical needs?</span>
                    <textarea id='txtCriticalNeeds' name='txtCriticalNeeds' className='add-only'></textarea>
                </p>
                <p className='w-750' >
                    <span className='eleHeader'>Has the child/adolescent had mental health treatment before?</span>
                    <input type='radio' id='rbMentalHealthTreatment_Yes' name='rbMentalHealthTreatment' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbMentalHealthTreatment_No' name='rbMentalHealthTreatment' className='add-only' value='No' /> No If yes, when & where?
                    <textarea id='txtMentalHealthTreatmentWhenWhere' name='txtMentalHealthTreatmentWhenWhere' className='add-only'></textarea>
                </p>
                <p className='w-750' >
                    <span className='eleHeader'>Has the child/adolescent had treatment for alcohol or drug use before?</span>
                    <input type='radio' id='rbDrugUseBefore_Yes' name='rbDrugUseBefore' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbDrugUseBefore_No' name='rbDrugUseBefore' className='add-only' value='No' /> No If yes, when & where?
                    <textarea id='txtDrugUseBeforeWhenWhere' name='txtDrugUseBeforeWhenWhere' className='add-only'></textarea>
                </p>
                <p className='w-750' >
                    <span className='eleHeader'>Has the child/adolescent had any legal involvement?</span>
                    <input type='radio' id='rbLegalInvolvement_Yes' name='rbLegalInvolvement' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbLegalInvolvement_No' name='rbLegalInvolvement' className='add-only' value='No' /> No If yes, please explain:
                    <textarea id='txtLegalInvolvementWhenWhere' name='txtLegalInvolvementWhenWhere' className='add-only'></textarea>
                </p>
                <p className='w-750' >
                    <span className='eleHeader'>Is the child currently on probation?</span>
                    <input type='radio' id='rbProbation_Yes' name='rbProbation' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbProbation_No' name='rbProbation' className='add-only' value='No' /> No
                </p>
                <table>
                    <tr>
                        <td className='w-400'> <span className='eleHeader'>If yes, Name of Probation Officer:</span> </td>
                        <td className='w-200'> <span className='eleHeader'>Parish:</span> </td>
                        <td className='w-150'> <span className='eleHeader'>Telephone:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-400'>  <input id='txtProbation' name='txtProbation' type='text' className='add-only' /> </td>
                        <td className='w-200'>  <input id='txtProbationParish' name='txtProbationParish' type='text' className='add-only' /> </td>
                        <td className='w-150'>  <input id='txtProbationTelephone' name='txtProbationTelephone' type='text' className='add-only' /> </td>
                    </tr>
                </table>
                <p className='w-750' >
                    <span className='eleHeader'>Has the child/adolescent been involved with DCFS?</span>
                    <input type='radio' id='rbInvolvedInDcfs_Yes' name='rbInvolvedInDcfs' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbInvolvedInDcfs_No' name='rbInvolvedInDcfs' className='add-only' value='No' /> No If yes, please explain:
                    <textarea id='txtInvolvedInDcfsExplain' name='txtInvolvedInDcfsExplain' className='add-only'></textarea>
                </p>
                <p className='w-750' >
                    <span className='eleHeader'>Does the child/adolescent have any current or ongoing medical problems?</span>
                    <input type='radio' id='rbOngoingMedicalProblems_Yes' name='rbOngoingMedicalProblems' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbOngoingMedicalProblems_No' name='rbOngoingMedicalProblems' className='add-only' value='No' /> No If yes, please explain:
                    <textarea id='txtOngoingMedicalProblemsExplain' name='txtOngoingMedicalProblemsExplain' className='add-only'></textarea>
                </p>
                <p className='w-750' >
                    It is very important for your therapy and medication management at Jackson Hands of Change, that we are able to have contact with your primary care provider (PCP).
                </p>
                <p className='w-750' >
                    <span className='eleHeader'>Do you give your permission for us to contact your PCP?</span>
                    <input type='radio' id='rbContactYourPcp_Yes' name='rbContactYourPcp' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbContactYourPcp_No' name='rbContactYourPcp' className='add-only' value='No' /> No (If yes, please complete release of information form)
                </p>
                <table>

                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Who is your primary doctor/medical provider?:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>City:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>  <input id='txtPrimaryDoctor' name='txtPrimaryDoctor' placeholder='Name' type='text' className='add-only' /> </td>
                        <td className='w-375'>  <input id='txtPrimaryDoctorCity' name='txtPrimaryDoctorCity' type='text' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Phone number:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>PCP Fax number:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>  <input id='txtPrimaryDoctorPhone' name='txtPrimaryDoctorPhone' type='text' className='add-only' /> </td>
                        <td className='w-375'>  <input id='txtPrimaryDoctorFax' name='txtPrimaryDoctorFax' type='text' className='add-only' /> </td>
                    </tr>
                </table>
                <p className='w-750' >
                    If you decline, please provide specific information for your denial.
                </p>
                <p className='w-750' >
                    <span className='eleHeader'>What medications does the child/adolescent take?</span>
                    <span className='small'>(Include non-prescription, herbal medicines & supplements) </span>
                    <textarea id='txtMedications' name='txtMedications' className='add-only'></textarea>
                </p>

                <table>

                    <tr>
                        <td className='w-200'> <span className='eleHeader'>Medicine:</span> </td>
                        <td className='w-150'> <span className='eleHeader'>Dose:</span> </td>
                        <td className='w-150'> <span className='eleHeader'>Frequency:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Who prescribes medication :</span> </td>
                    </tr>
                    <tr>
                        <td className='w-200'>  <input id='txtMedicine_1' name='txtMedicine_1' type='text' className='add-only' /> </td>
                        <td className='w-150'>  <input id='txtDose_1' name='txtDose_1' type='text' className='add-only' /> </td>
                        <td className='w-150'>  <input id='txtFrequency_1' name='txtFrequency_1' type='text' className='add-only' /> </td>
                        <td className='w-250'>  <input id='txtPrescribes_1' name='txtPrescribes_1' type='text' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-200'>  <input id='txtMedicine_2' name='txtMedicine_2' type='text' className='add-only' /> </td>
                        <td className='w-150'>  <input id='txtDose_2' name='txtDose_2' type='text' className='add-only' /> </td>
                        <td className='w-150'>  <input id='txtFrequency_2' name='txtFrequency_2' type='text' className='add-only' /> </td>
                        <td className='w-250'>  <input id='txtPrescribes_2' name='txtPrescribes_2' type='text' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-200'>  <input id='txtMedicine_3' name='txtMedicine_3' type='text' className='add-only' /> </td>
                        <td className='w-150'>  <input id='txtDose_3' name='txtDose_3' type='text' className='add-only' /> </td>
                        <td className='w-150'>  <input id='txtFrequency_3' name='txtFrequency_3' type='text' className='add-only' /> </td>
                        <td className='w-250'>  <input id='txtPrescribes_3' name='txtPrescribes_3' type='text' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-200'>  <input id='txtMedicine_4' name='txtMedicine_4' type='text' className='add-only' /> </td>
                        <td className='w-150'>  <input id='txtDose_4' name='txtDose_4' type='text' className='add-only' /> </td>
                        <td className='w-150'>  <input id='txtFrequency_4' name='txtFrequency_4' type='text' className='add-only' /> </td>
                        <td className='w-250'>  <input id='txtPrescribes_4' name='txtPrescribes_4' type='text' className='add-only' /> </td>
                    </tr>

                </table>
                <table>

                    <tr>
                        <td className='w-500'> <span className='eleHeader'>Which pharmacy do you use?</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Phone:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-500'>  <input id='txtPharmacyUse' name='txtPharmacyUse' type='text' className='add-only' /> </td>
                        <td className='w-250'>  <input id='txtPharmacyUsePhone' name='txtPharmacyUsePhone' type='text' className='add-only' /> </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>Please list any allergies, including medication allergies/sensitivities:</span>
                    <textarea id='txtListAllergies' name='txtListAllergies' className='add-only'></textarea>

                </p>
                <p className='w-750' >
                    <span className='eleHeader'>Do you authorize Jackson Hands of Change to call your phone?</span>
                    <input type='radio' id='rbCallYourPhone_Yes' name='rbCallYourPhone' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbCallYourPhone_No' name='rbCallYourPhone' className='add-only' value='No' /> No
                </p>
                <p className='w-750' >
                    <span className='eleHeader'>To leave messages?</span>
                    <input type='radio' id='rbLeaveMessage_Yes' name='rbLeaveMessage' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbLeaveMessage_No' name='rbLeaveMessage' className='add-only' value='No' /> No
                </p>
                <p className='w-750' >
                    <span className='eleHeader'>To send you text messages?</span>
                    <input type='radio' id='rbTextMessage_Yes' name='rbTextMessage' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbTextMessage_No' name='rbTextMessage' className='add-only' value='No' /> No
                </p>

            </div>
        </form>

    )
}










